export default "__VITE_ASSET__tJ6YvoHP__"